import { produce } from 'immer'
import type { State } from '../typings'

export type CommitAction = {
  type: 'commit'
  payload: boolean
}

export const commitAction = (state: State, payload: CommitAction['payload']) =>
  produce(state, (draft) => {
    draft.commitProcessing = payload
  })

export const commitActionCreator = (
  payload: CommitAction['payload'],
): CommitAction => ({
  type: 'commit',
  payload,
})
